export class PersonalNameParent {
  constructor() {
    this.list = []
  }

  add(item) {
    this.list.push(PersonalName.build(item))
  }

  update(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    this.list.splice(index, 1, PersonalName.build(item))
  }

  remove(id) {
    const index = this.list.findIndex(el => el.id === id)
    this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  build(obj) {
    if (obj) {
      this.list = obj.map(el => PersonalName.build(el))
    }
    return this
  }
}

export class PersonalName {
  constructor() {
    this.id = null
    this.firstName = null
    this.lastName = null
    this.middleName = null
    this.firstNameGenitive = null
    this.lastNameGenitive = null
    this.middleNameGenitive = null
    this.personalData = null
  }

  getForAPI() {
    return {
      id: this.id,
      firstName: this.firstName,
      lastName: this.lastName,
      middleName: this.middleName,
      firstNameGenitive: this.firstNameGenitive,
      lastNameGenitive: this.lastNameGenitive,
      middleNameGenitive: this.middleNameGenitive,
      personalData: this.personalData,
    }
  }

  static build(obj) {
    const _this = new PersonalName()
    if (obj) {
      _this.id = obj.id
      _this.firstName = obj.firstName
      _this.lastName = obj.lastName
      _this.middleName = obj.middleName
      _this.firstNameGenitive = obj.firstNameGenitive
      _this.lastNameGenitive = obj.lastNameGenitive
      _this.middleNameGenitive = obj.middleNameGenitive
      _this.personalData = obj.personalData
    }
    return _this
  }
}
